import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Button, Table,
} from "reactstrap";
import { alertsRepo } from "data/repositories/alertsRepo";
import EmptyState from "components/EmptyState";

export default function MyAlerts() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    setAlerts(alertsRepo.list());
  }, []);

  const handleRemove = (id) => {
    alertsRepo.remove(id);
    setAlerts(alertsRepo.list());
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <h2 className="text-white mb-0">Bildirimlerim</h2>
            </Col>
            <Col className="text-right">
              <Button color="white" size="sm" tag={Link} to="/admin/alerts/new">
                + Yeni Bildirim
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow">
          <CardHeader><h3 className="mb-0">Tüm Bildirimler</h3></CardHeader>
          <CardBody>
            {alerts.length === 0 ? (
              <EmptyState title="Bildirim yok" />
            ) : (
              <Table className="align-items-center" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>İl</th>
                    <th>Tema</th>
                    <th>Tarih aralığı</th>
                    <th>Oluşturulma</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {alerts.map((a) => (
                    <tr key={a.id}>
                      <td>{a.provinceId || "Tümü"}</td>
                      <td>{a.theme || "Tümü"}</td>
                      <td>{a.dateFrom || "-"} / {a.dateTo || "-"}</td>
                      <td>{a.createdAt ? new Date(a.createdAt).toLocaleDateString("tr-TR") : "-"}</td>
                      <td>
                        <Button color="danger" size="sm" onClick={() => handleRemove(a.id)}>
                          Sil
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
